export const SHOP = {
  // Header
  logo: "header-logo",
  searchInput: "header-search-input",
  cartBtn: "header-cart-btn",
  cartCount: "header-cart-count",
  loginBtn: "header-login-btn",
  announcementBar: "announcement-bar",

  // Hero
  heroSlider: "hero-slider",
  heroSlide: (id) => `hero-slide-${id}`,
  heroCta: "hero-cta-btn",

  // Categories
  categorySection: "category-section",
  categoryTile: (slug) => `category-tile-${slug}`,

  // Deals / Products
  dealsSection: "deals-section",
  productsSection: "products-section",
  productCard: (id) => `product-card-${id}`,
  addToCartBtn: (id) => `add-to-cart-${id}`,
  qtyIncrease: (id) => `qty-increase-${id}`,
  qtyDecrease: (id) => `qty-decrease-${id}`,

  // Cart drawer
  cartDrawer: "cart-drawer",
  cartItem: (id) => `cart-item-${id}`,
  cartCheckout: "cart-checkout-btn",
  cartEmpty: "cart-empty",
  cartSubtotal: "cart-subtotal",
  cartRemove: (id) => `cart-remove-${id}`,
  cartWhatsappBtn: "cart-whatsapp-btn",

  // WhatsApp
  productWhatsappBtn: (id) => `whatsapp-order-${id}`,
  floatingWhatsappBtn: "floating-whatsapp-btn",

  // Checkout dialog
  checkoutDialog: "checkout-dialog",
  checkoutName: "checkout-name-input",
  checkoutPhone: "checkout-phone-input",
  checkoutAddress: "checkout-address-input",
  checkoutPincode: "checkout-pincode-input",
  checkoutPlaceOrderBtn: "checkout-place-order-btn",
  orderSuccess: "order-success",

  // Login dialog (mock OTP)
  loginDialog: "login-dialog",
  loginPhoneInput: "login-phone-input",
  loginRequestOtp: "login-request-otp-btn",
  loginOtpInput: "login-otp-input",
  loginVerifyBtn: "login-verify-btn",
  loginSuccess: "login-success",

  // Trust badges & misc
  trustBadges: "trust-badges-section",
  testimonials: "testimonials-section",
  footer: "site-footer",
};
